/**
 * Avalara © 2017
 * file: engines/opus_ui/src/index.jsx
 */
import axios from 'axios';
import queryString from 'query-string';
import registerServiceWorker from './registerServiceWorker';
import React from 'react';
import ReactDOM from 'react-dom';
import configureStore from './redux/configure_store';
import createHistory from 'history/createHashHistory';
// import { hashHistory } from 'react-router';
// import { syncHistoryWithStore } from 'react-router-redux';
import { authEventHandler } from './actions/auth';
import { axios401ResponseInterceptor } from './intercepters/axios-401-response-interceptor';
import axiosRequestInterceptor from './intercepters/axios-request-interceptor';
import { getReturnUrl, removeReturnUrl, setJwt } from './utils/store';
import './index.css';
import './polyfills/polyfills';
import Root from './root';
import config from './config';

console.debug('initializing react app');
console.debug('../config', config);

// Temp change to remove the token from localStorage.
// Going forward we are going to use cookie for JWT token.
localStorage.removeItem('token');

authEventHandler();

axiosRequestInterceptor();

axios401ResponseInterceptor();

setTimeout(() => {
  const history = createHistory();
  const store = configureStore(history);

  // Create an enhanced history that syncs navigation events with the store
  // const history = syncHistoryWithStore(hashHistory, store);

  try {
    if (
      !process.env.REACT_APP_ENV ||
      process.env.REACT_APP_ENV === 'development'
    ) {
      const parsedQs = queryString.parse(window.location.search);
      // const token = getJwt();

      if (parsedQs && parsedQs.token) {
        // store.dispatch(loginUserSuccess(token));
        setJwt(parsedQs.token);
        window.history.pushState('', '', window.location.href.split('?')[0]);
      }
      // else if (token) {
      //   console.log('going there');
      //   // store.dispatch(loginUserSuccess(token));
      // }
    }

    const returnPath = getReturnUrl();
    if (returnPath) {
      window.location.hash = returnPath.replace('#/', '');
      removeReturnUrl();
    }

    axios.defaults.headers.common['X-Avalara-Client'] = 'OPUS_UI';
  } catch (e) {
    // console.error(e.message, e.stack);
  }

  ReactDOM.render(
    <Root store={store} history={history} />,
    document.getElementById('root')
  );

  registerServiceWorker();
}, 300);
